

















import { mapActions, mapGetters } from 'vuex';

import { UiButton } from '../keen-ui';

import { CONTEXT_CONSTS } from '../../store/context/context.consts';

export default {
  name: 'no-data-found',
  components: {
    UiButton
  },
  computed: {
    ...mapGetters(CONTEXT_CONSTS.moduleName, {
      appliedFiltersCount: CONTEXT_CONSTS.getters.appliedFiltersCount
    })
  },
  props: {
    messages: Object
  },
  methods: {
    ...mapActions(CONTEXT_CONSTS.moduleName, {
      clearFilters: CONTEXT_CONSTS.actions.clearFilters
    }),
    onClearFilters: async function () {
      await this.clearFilters();
      this.$router.replace({ name: this.$route.name });
    }
  }
};

